'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { STYLESHEETS_FETCH, FINDER_FILE_DELETE, FINDER_FILE_RESTORE_DELETED } from 'DesignData/actions/ActionTypes';
import { CSS } from 'DesignData/constants/TemplateFileTypes';

const getUpdatedStateData = sheets => {
  const rawData = sheets;
  const byId = {};
  const byPath = {};
  const orderById = new Array(sheets.length);
  sheets.forEach((s, idx) => {
    orderById[idx] = s.id;
    byId[s.id] = byPath[s.path] = s;
  });
  return {
    rawData,
    byId,
    byPath,
    orderById
  };
};
/*
 * Export
 */


export default function stylesheets(state = SeamlessImmutable({
  rawData: [],
  byId: {},
  byPath: {},
  orderById: []
}), action) {
  switch (action.type) {
    case STYLESHEETS_FETCH:
      {
        const {
          stylesheets: sheets
        } = action;

        if (!sheets) {
          return state;
        }

        return state.replace(getUpdatedStateData(sheets), {
          deep: true
        });
      }

    case FINDER_FILE_DELETE:
      {
        if (action.fileType === CSS) {
          const {
            rawData
          } = state;
          return state.replace(getUpdatedStateData(rawData.filter(sheet => sheet.id !== action.fileId)), {
            deep: true
          });
        }

        return state;
      }

    case FINDER_FILE_RESTORE_DELETED:
      {
        if (action.fileType === CSS) {
          const {
            rawData
          } = state;
          return state.replace(getUpdatedStateData([...rawData, action.file]), {
            deep: true
          });
        }

        return state;
      }

    default:
      return state;
  }
}